import Vue from "vue";
import CollectFile from './CollectFile/CollectFile.vue'; 
import DeleteCollection from './DeleteCollection/DeleteCollection.vue'; 
import DeleteFile from './DeleteFile/DeleteFile.vue'; 
import DeleteSpace from './DeleteSpace/DeleteSpace.vue'; 
import DesktopFileHolder from './DesktopFileHolder/DesktopFileHolder.vue'; 
import EditSpace from './EditSpace/EditSpace.vue'; 
import FileEditorPreview from './FileEditorPreview/FileEditorPreview.vue'; 
import FileEditorTools from './FileEditorTools/FileEditorTools.vue'; 
import FileFull from './FileFull/FileFull.vue'; 
import FileFullDetailFields from './FileFullDetailFields/FileFullDetailFields.vue'; 
import FileFullPreview from './FileFullPreview/FileFullPreview.vue'; 
import FilesHolder from './FilesHolder/FilesHolder.vue'; 
import FolderInputFormWrapper from './FolderInputFormWrapper/FolderInputFormWrapper.vue'; 
import HomeLeftContent from './HomeLeftContent/HomeLeftContent.vue'; 
import HomeRightContent from './HomeRightContent/HomeRightContent.vue'; 
import ImageSlider from './ImageSlider/ImageSlider.vue'; 
import LeftSidebar from './LeftSidebar/LeftSidebar.vue'; 
import Login from './Login/Login.vue'; 
import MobileAddCollection from './MobileAddCollection/MobileAddCollection.vue'; 
import MobileAddFolder from './MobileAddFolder/MobileAddFolder.vue'; 
import MobileEmpty from './MobileEmpty/MobileEmpty.vue'; 
import MobilePage from './MobilePage/MobilePage.vue'; 
import MobileTags from './MobileTags/MobileTags.vue'; 
import MoveFile from './MoveFile/MoveFile.vue'; 
import Navigation from './Navigation/Navigation.vue'; 
import OverlayPage from './OverlayPage/OverlayPage.vue'; 
import PaneContent from './PaneContent/PaneContent.vue'; 
import PaneHolder from './PaneHolder/PaneHolder.vue'; 
import QuickTransfer from './QuickTransfer/QuickTransfer.vue'; 
import RenameCollection from './RenameCollection/RenameCollection.vue'; 
import RenameFile from './RenameFile/RenameFile.vue'; 
import RightSidebar from './RightSidebar/RightSidebar.vue'; 
import SearchOverlay from './SearchOverlay/SearchOverlay.vue'; 
import SearchResults from './SearchResults/SearchResults.vue'; 
import Settings from './Settings/Settings.vue'; 
import SidebarEditSpace from './SidebarEditSpace/SidebarEditSpace.vue'; 
import Space from './Space/Space.vue'; 
import SpacesHolder from './SpacesHolder/SpacesHolder.vue'; 
import StepWrapper from './StepWrapper/StepWrapper.vue'; 
import TransferHome from './TransferHome/TransferHome.vue'; 
import TransferPreview from './TransferPreview/TransferPreview.vue'; 
import TransferReady from './TransferReady/TransferReady.vue'; 
import TransferSucces from './TransferSucces/TransferSucces.vue'; 
import TransferUpload from './TransferUpload/TransferUpload.vue'; 
import TreeOverview from './TreeOverview/TreeOverview.vue'; 
import UpdateSpace from './UpdateSpace/UpdateSpace.vue'; 
import Upload from './Upload/Upload.vue'; 
import UploadHome from './UploadHome/UploadHome.vue'; 
import UploadPreview from './UploadPreview/UploadPreview.vue'; 
import WelcomeRootfolders from './WelcomeRootfolders/WelcomeRootfolders.vue'; 


const importAllVue = () => {
	Vue.component("collect-file", CollectFile); 
	Vue.component("delete-collection", DeleteCollection); 
	Vue.component("delete-file", DeleteFile); 
	Vue.component("delete-space", DeleteSpace); 
	Vue.component("desktop-file-holder", DesktopFileHolder); 
	Vue.component("edit-space", EditSpace); 
	Vue.component("file-editor-preview", FileEditorPreview); 
	Vue.component("file-editor-tools", FileEditorTools); 
	Vue.component("file-full", FileFull); 
	Vue.component("file-full-detail-fields", FileFullDetailFields); 
	Vue.component("file-full-preview", FileFullPreview); 
	Vue.component("files-holder", FilesHolder); 
	Vue.component("folder-input-form-wrapper", FolderInputFormWrapper); 
	Vue.component("home-left-content", HomeLeftContent); 
	Vue.component("home-right-content", HomeRightContent); 
	Vue.component("image-slider", ImageSlider); 
	Vue.component("left-sidebar", LeftSidebar); 
	Vue.component("login", Login); 
	Vue.component("mobile-add-collection", MobileAddCollection); 
	Vue.component("mobile-add-folder", MobileAddFolder); 
	Vue.component("mobile-empty", MobileEmpty); 
	Vue.component("mobile-page", MobilePage); 
	Vue.component("mobile-tags", MobileTags); 
	Vue.component("move-file", MoveFile); 
	Vue.component("navigation", Navigation); 
	Vue.component("overlay-page", OverlayPage); 
	Vue.component("pane-content", PaneContent); 
	Vue.component("pane-holder", PaneHolder); 
	Vue.component("quick-transfer", QuickTransfer); 
	Vue.component("rename-collection", RenameCollection); 
	Vue.component("rename-file", RenameFile); 
	Vue.component("right-sidebar", RightSidebar); 
	Vue.component("search-overlay", SearchOverlay); 
	Vue.component("search-results", SearchResults); 
	Vue.component("settings", Settings); 
	Vue.component("sidebar-edit-space", SidebarEditSpace); 
	Vue.component("space", Space); 
	Vue.component("spaces-holder", SpacesHolder); 
	Vue.component("step-wrapper", StepWrapper); 
	Vue.component("transfer-home", TransferHome); 
	Vue.component("transfer-preview", TransferPreview); 
	Vue.component("transfer-ready", TransferReady); 
	Vue.component("transfer-succes", TransferSucces); 
	Vue.component("transfer-upload", TransferUpload); 
	Vue.component("tree-overview", TreeOverview); 
	Vue.component("update-space", UpdateSpace); 
	Vue.component("upload", Upload); 
	Vue.component("upload-home", UploadHome); 
	Vue.component("upload-preview", UploadPreview); 
	Vue.component("welcome-rootfolders", WelcomeRootfolders); 

};

export default importAllVue;
